import React, { FC, memo } from 'react'

import { EInstitutionType } from '@ucheba/store/institutions/item/types'
import { Heading } from '@ucheba/ui/components/Heading/desktop'

import SchoolInfo from './InstitutionSchoolInfo'
import UniversityInfo from './InstitutionUniversityInfo'

import { IMainInfoProps } from '../types'
import { texts } from '../constants'

const InstitutionMainInfo: FC<IMainInfoProps> = ({
  type,
  schoolInfo,
  abroadInfo,
  tags,
}) => {
  const { title } = texts

  return (
    <>
      <Heading h2={title} spacing='small' />

      {type === EInstitutionType.School && <SchoolInfo data={schoolInfo} />}
      {(type === EInstitutionType.University ||
        type === EInstitutionType.ForeignUniversity) && (
        <UniversityInfo data={abroadInfo} tags={tags} />
      )}
    </>
  )
}

export default memo(InstitutionMainInfo)
